import '../scss/base-px.scss';
import '../scss/main-px.scss';
import art from '../views/art';
import { getUrlParam } from './utils';
import * as service from './service';
import events from './events';
import 'babel-polyfill';
import loading from './loading.js';
(function () {
  loading();
  art.render();
  service.init();
  events.init();
  dataLayer.push({
    event: 'entrance',
    scid: getUrlParam('scid'),
    cid: getUrlParam('cid'),
  });
})();
